import { defineStore } from 'pinia';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { IManagerData, IManagersStrapiResponse } from '~/types/notifications';

export const useStoreManagers = defineStore('managers', {
  state: () => ({
    managers: [] as IManagerData[],
    requestPromise: null as Promise<IManagersStrapiResponse> | null,
  }),

  actions: {
    async loadManagers() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'bannerComplex',
          'bannerComplex.desktopAssetFront',
          'bannerComplex.desktopAssetBack',
          'bannerComplex.mobileAsset',
        ]);

        this.requestPromise = strapi()
          .get('managers', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        this.managers = parseCollectionData(response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
